import { useDispatch, useSelector } from "react-redux";
import { hasAuthority, getCoaPermissions } from "../../../../../utils/authorities";
import { Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import FailedProductModal from "../../../../pages/CertificateAnalysis/FailedModal";
import { useState } from "react";
import { useParams } from "react-router";
import { selectAllInitialSteps, selectCurrentCycle } from "../../../../slices/common";
import { approveQualityAssurance, approveQcLead } from "../../../../slices/qualityApproval";
import { approveQualityControl, selectQCIsLoading } from "../../../../slices/qualityControl";
import RejectCoaForm from "../../RejectCoaForm";

const CoaFormButtons = ({setIsDraft, patientData, formik, fetchPatientInfo, updateTimeLine, setCoaFormExpanded, fetchCoaForms }) => {
    const dispatch = useDispatch();
    const currentCycle = useSelector(selectCurrentCycle)
    const { id } = useParams()
    const isLoading = useSelector(selectQCIsLoading)
    const [failedModalOpen, setFailedModalOpen] = useState(false)
    const [failedModalRejectCoa, setFailedModalRejectCoa] = useState(false)
    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || [];
    const coaFormId = currentCycle?.coa_forms_id 

    const allInitialSteps = useSelector(selectAllInitialSteps)
    const approvalStatus = allInitialSteps?.find(op => op.slug == "qc-testing")
    const manufectureStatus = allInitialSteps?.find(op => op.slug == "product-manufactured")?.status

    const qaApprovalStatus = allInitialSteps?.find(op => op.slug == "qa-review")
    const {
    canQualityApproverApporve,
    canQualityApproverReject,
    canQCLeadReject,
    canQCLeadApprove
  } = getCoaPermissions(hasAuthority,bmr_permissions);

  const handleApproved = async (check=false) => {
        if (approvalStatus?.status == 4 && check) {
             await formik.validateForm();

  // If there's an error in lead_remarks, stop submission
  if (!formik.values.lead_remarks || formik.values.lead_remarks.trim() === "") {
    formik.setFieldTouched("lead_remarks", true, true);
    return; // ⛔ stop submit
  }

            const approvalData = {
                patient_id: patientData?.patient_information?.id,
                product_manufacturing_id: currentCycle?.product_manufacturing_id,
                feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
                qr_code_generated_id: patientData?.qrCode_id,
                coa_form_id: coaFormId,
                lead_remarks: formik?.values?.lead_remarks
            };
          await dispatch(approveQcLead(approvalData));
        }else if (approvalStatus?.status == 2 && qaApprovalStatus?.status == 0) {
        if (!formik.values.qa_remarks || formik.values.qa_remarks.trim() === "") {
         formik.setFieldTouched("qa_remarks", true, true);
         return; // ⛔ stop submit
          }
            const approvalData = {
                patient_id: patientData?.patient_information?.id,
                product_manufacturing_id: currentCycle?.product_manufacturing_id,
                feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
                qr_code_generated_id: patientData?.qrCode_id,
                coa_form_id: coaFormId,
                remarks :formik?.values?.qa_remarks
            };

            await dispatch(approveQualityAssurance(approvalData));
        } else {
            const approvalData = {
                patient_id: patientData?.patient_information?.id,
                product_manufacturing_id: currentCycle?.product_manufacturing_id,
                feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
                qr_code_generated_id: patientData?.qrCode_id,
            };
            await dispatch(approveQualityControl({ formData: approvalData, id: coaFormId }));
        }

        setCoaFormExpanded(false)
        await fetchCoaForms(coaFormId)
        await updateTimeLine()
        await fetchPatientInfo()
    }
    return <div>
        <Grid className="flex gap-4 w-full max-w-[35rem]">
            {approvalStatus?.status == 0 && manufectureStatus == '2' && hasAuthority(["quality-control-listing"], bmr_permissions) && <LoadingButton
                type="submit"
                variant="contained"
                 onClick={() => setIsDraft(false)}
                className="w-25"
            >
                Submit
            </LoadingButton>}
            {approvalStatus?.status == 0 && manufectureStatus == '2' && hasAuthority(["quality-control-listing"], bmr_permissions) && <LoadingButton
                                                type="submit"
                                                size="small"
                                                onClick={() => setIsDraft(true)}
                                                className="!w-[100px] bg-[#ffa500]"
                                              >
                                                Save as Draft
                                              </LoadingButton>}
            {/* qc lead approval */} 
             {(coaFormId && approvalStatus?.status !== 0 
                && (formik.values.reviewed_by != null || formik.values.reviewed_by != "")
                && (canQCLeadApprove && approvalStatus?.status == 4))
                ? <LoadingButton
                    loading={isLoading}
                    type="button"
                    onClick={() => handleApproved(true)}
                    variant="contained"
                    className="w-25  bg-[#00B976]"
                >
                 Approve
                </LoadingButton> : ( (coaFormId
                && canQualityApproverApporve
                && (formik.values.reviewed_by != null && formik.values.reviewed_by != "")
                && approvalStatus?.status != 1 && approvalStatus?.status != 3 && approvalStatus?.status !== 0  && qaApprovalStatus?.status == 0))
                ? <LoadingButton
                    loading={isLoading}
                    type="button"
                    onClick={() => handleApproved()}
                    variant="contained"
                    className="w-25  bg-[#00B976]"
                >
                    Approve
                </LoadingButton>:''}
                {(coaFormId
                && canQCLeadReject && approvalStatus?.status == 4 && approvalStatus?.status !== 0 )
                ? <LoadingButton
                    type="button"
                    onClick={() => setFailedModalRejectCoa(true)}
                    className="w-25 bg-[#FF5757] text-white hover:bg-[#FF4444]"
                    variant="contained"

                >
                    Reject
                </LoadingButton> : (coaFormId && approvalStatus?.status != 0 && (canQualityApproverReject
                && approvalStatus?.status == 2 && qaApprovalStatus?.status == 0))
                ? <LoadingButton
                    type="button"
                    onClick={() => setFailedModalOpen(true)}
                    className="w-25 bg-[#FF5757] text-white hover:bg-[#FF4444]"
                    variant="contained"

                >
                    Mark As Failed
                </LoadingButton>:''}

        </Grid>
        {/* Failed Product Modal */}
        <FailedProductModal
            open={failedModalOpen}
            onClose={() => setFailedModalOpen(false)}
            patientData={{
                ...patientData,
            }}
            id={id}
            fetchPatientInfo={fetchPatientInfo}
            updateTimeLine={updateTimeLine}
            feasibilityId={patientData?.feasibility_assessments_id}
            coaFormId={coaFormId}
            row={patientData}
        />
       <RejectCoaForm
            open={failedModalRejectCoa}
            setOpen={() => setFailedModalRejectCoa(false)}
            fetchPatientInfo={fetchPatientInfo}
            updateTimeLine={updateTimeLine}
            patient_id={patientData?.patient_information?.id}
            product_manufacturing_id={currentCycle?.product_manufacturing_id}
            feasibility_assessment_id={currentCycle?.feasibility_assessments_id}
            qr_code_generated_id={patientData?.qrCode_id}
            coaFormId={coaFormId}
        />
        
    </div>
}
export default CoaFormButtons;